import React from 'react';
import { Skeleton } from 'antd';

export default function DashboardStatCard({
  title,
  children,
  loading = false,
  onClick,
  className = '',
}) {
  const clickable = Boolean(onClick);
  return (
    <div
      className={`dashboard-stat ${clickable ? 'dashboard-stat-card--clickable' : ''} ${className}`}
      onClick={onClick}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <>
          <div className="stat-title">{title}</div>
          {children}
        </>
      )}
    </div>
  );
}
